module.exports = __webpack_public_path__ + "static/media/Pokemon.53c18ccf.png";